module.exports = __webpack_public_path__ + "static/media/Acupuncture.df09ff08.jpg";